import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import Toggle from './Toggle'
import { selectLocationIds } from './selectors'
import SelectAll from './SelectAll'
import SelectNone from './SelectNone'

const ProductionReportLocations = ({ ids }) => (
  <div className='btn-group btn-group--flex' style={{ padding: 0 }}>
    {ids.map(id => (
      <Toggle key={id} id={id} />
    ))}
    <SelectAll />
    <SelectNone />
  </div>
)

ProductionReportLocations.defaultProps = {
  ids: []
}

ProductionReportLocations.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.number)
}

const mapStateToProps = (state) => ({
  ids: selectLocationIds(state)
})

export default connect(mapStateToProps)(ProductionReportLocations)
